import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast, Popup } from 'vant'
import routes from '@/routers'

Vue.use(VueRouter)
Vue.use(Popup)
Vue.use(Toast)

export const router = new VueRouter({
  mode: 'history',
  // base: process.env.NODE_ENV === 'production' ? '/fe-app/' : '/',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 白名单页面
  let noLoginArr = ['/login', '/team/team-login', '/batch', '/batch/detail']
  let isCur = false
  for (let i of noLoginArr) {
    if (to.path == i) {
      isCur = true
    }
  }
  if (isCur) {
    //白名单内不做登录判断，直接next
    next()
  } else if (!sessionStorage.getItem('Authorization')) {
    // 根据当前页面路径跳转登录首页，team模块跳转团队登录
    if (to.path.indexOf('/team') != -1) {
      // 跳转团队登录页面
      next('/team/team-login')
      return
    } else {
      // 跳转登录页面
      next('/login')
    }
    return
  }
  next()
})

Vue.router = router

export default {
  router
}
